import { defineTypedEvent, } from '../typed-event/typed-event';
export function defineElementEvent() {
    return defineTypedEvent();
}
export function createEventDescriptorMap(eventsInit) {
    if (!eventsInit) {
        return {};
    }
    return Object.keys(eventsInit)
        .filter((currentElementEventKey) => {
        if (typeof currentElementEventKey !== 'string') {
            throw new Error(`Expected event key of type string but got type "${typeof currentElementEventKey}" for key ${currentElementEventKey}`);
        }
        if (currentElementEventKey === '') {
            throw new Error(`Got empty string for events key.`);
        }
        return true;
    })
        .reduce((accum, currentElementEventKey) => {
        const eventObject = defineTypedEvent()(currentElementEventKey);
        accum[currentElementEventKey] = eventObject;
        return accum;
    }, {});
}
